<!-- <div class="logo-src h-100 w-100 m-2 p-2"></div> -->

<div class="auth" style="background-color: whitesmoke">
  <!-- <app-header></app-header> -->

  <!-- <div class="logo-src"></div> -->
  <div class="row d-flex justify-content-center g-0">
    <div class="slider-light">
      <div
        class="position-relative h-100 d-flex justify-content-center align-items-center"
      >
        <div class="slide-img-bg"></div>
        <div class="slider-content" style="color: black">
          <h3 style="text-align: center">
            <!-- <h4 class="mb-0 text-center"> -->
            <img src="../../../assets/images/logo-blue.png" width="200" />
            <div>&nbsp;</div>
            <!-- </h4> -->
            <br />
            {{ "Form.THANK_YOU_TITLE" | translate }}
          </h3>
          <div>&nbsp;</div>
          <div *ngIf="id == 'registration'">
            <p style="text-align: center">
              You're all set to enhance your experience. Here’s what to do next:
            </p>

            <ol>
              <li class="align-items-left">
                <strong>Check your email </strong> and
                <strong>active </strong> your account.
              </li>
              <li>
                <strong>
                  <a
                    href="https://chromewebstore.google.com/detail/theappsherpa/gacojacjjlaplpbkepmhfhkeanjfpgei"
                    target="_blank"
                    >Download our Chrome extension
                  </a>
                </strong>
                to unlock the best features.
              </li>
            </ol>
            <p style="text-align: center">
              Thank you for joining us—we’re excited to have you on board!
            </p>
            <!-- {{ "Form.THANK_YOU_MESSAGE" | translate }} -->
            <!-- </p> -->
          </div>
          <p *ngIf="id == 'setpassword'">
            {{ "Form.THANK_YOU_MESSAGE_SETPASSWORD" | translate }}
          </p>
        </div>
      </div>
    </div>
  </div>
</div>
